import React, { Component } from 'react';
import './style.less';

export default class Nothing extends Component {
    render(){
        return(
            <div className="nothing">
                <div className="img"></div>
                <div className="text">这里空空如也～</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/Nothing/Nothing.jsx